module.exports = {
	"config": {
		"siteTitle": "Coriolan UI",
		"siteDescr": "sass mixins pack",
		"siteAuthor": "",
		"siteNpmUrl": "https://www.npmjs.com/package/coriolan-ui",
		"siteGithubUrl": "https://github.com/coriolan-ui/coriolan-ui.github.io",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"title": "404",
				"layout": "page",
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "clearfix-ie8.md",
				"ext": "md",
				"name": "clearfix-ie8",
				"extname": ".md",
				"basename": "clearfix-ie8.md",
				"dirname": "mixins",
				"stem": "clearfix-ie8",
				"path": "mixins/clearfix-ie8.md"
			},
			"requirePath": "mixins/clearfix-ie8.md",
			"path": "/mixins/clearfix-ie8/",
			"data": {
				"id": 3,
				"title": "Clearfix IE8",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "clearfix.md",
				"ext": "md",
				"name": "clearfix",
				"extname": ".md",
				"basename": "clearfix.md",
				"dirname": "mixins",
				"stem": "clearfix",
				"path": "mixins/clearfix.md"
			},
			"requirePath": "mixins/clearfix.md",
			"path": "/mixins/clearfix/",
			"data": {
				"id": 2,
				"title": "Clearfix",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "ellipsis.md",
				"ext": "md",
				"name": "ellipsis",
				"extname": ".md",
				"basename": "ellipsis.md",
				"dirname": "mixins",
				"stem": "ellipsis",
				"path": "mixins/ellipsis.md"
			},
			"requirePath": "mixins/ellipsis.md",
			"path": "/mixins/ellipsis/",
			"data": {
				"id": 5,
				"title": "Ellipsis",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "media.md",
				"ext": "md",
				"name": "media",
				"extname": ".md",
				"basename": "media.md",
				"dirname": "mixins",
				"stem": "media",
				"path": "mixins/media.md"
			},
			"requirePath": "mixins/media.md",
			"path": "/mixins/media/",
			"data": {
				"id": 1,
				"title": "Media",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "placeholder.md",
				"ext": "md",
				"name": "placeholder",
				"extname": ".md",
				"basename": "placeholder.md",
				"dirname": "mixins",
				"stem": "placeholder",
				"path": "mixins/placeholder.md"
			},
			"requirePath": "mixins/placeholder.md",
			"path": "/mixins/placeholder/",
			"data": {
				"id": 6,
				"title": "Placeholder",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "px-to-em.md",
				"ext": "md",
				"name": "px-to-em",
				"extname": ".md",
				"basename": "px-to-em.md",
				"dirname": "mixins",
				"stem": "px-to-em",
				"path": "mixins/px-to-em.md"
			},
			"requirePath": "mixins/px-to-em.md",
			"path": "/mixins/px-to-em/",
			"data": {
				"id": 7,
				"title": "Pixels to Ems",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "px-to-rem.md",
				"ext": "md",
				"name": "px-to-rem",
				"extname": ".md",
				"basename": "px-to-rem.md",
				"dirname": "mixins",
				"stem": "px-to-rem",
				"path": "mixins/px-to-rem.md"
			},
			"requirePath": "mixins/px-to-rem.md",
			"path": "/mixins/px-to-rem/",
			"data": {
				"id": "08",
				"title": "Pixels to Rems",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "mixins",
				"base": "ratio.md",
				"ext": "md",
				"name": "ratio",
				"extname": ".md",
				"basename": "ratio.md",
				"dirname": "mixins",
				"stem": "ratio",
				"path": "mixins/ratio.md"
			},
			"requirePath": "mixins/ratio.md",
			"path": "/mixins/ratio/",
			"data": {
				"id": 4,
				"title": "Ratio",
				"layout": "post",
				"category": "mixin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages",
				"stem": "index",
				"path": "pages/index.md"
			},
			"requirePath": "pages/index.md",
			"path": "/",
			"data": {
				"title": "Home",
				"layout": "home",
				"path": "/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "installation.md",
				"ext": "md",
				"name": "installation",
				"extname": ".md",
				"basename": "installation.md",
				"dirname": "pages",
				"stem": "installation",
				"path": "pages/installation.md"
			},
			"requirePath": "pages/installation.md",
			"path": "/installation/",
			"data": {
				"title": "Installation",
				"layout": "page",
				"path": "/installation/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "menu.md",
				"ext": "md",
				"name": "menu",
				"extname": ".md",
				"basename": "menu.md",
				"dirname": "pages",
				"stem": "menu",
				"path": "pages/menu.md"
			},
			"requirePath": "pages/menu.md",
			"path": "/menu/",
			"data": {
				"title": "Menu",
				"layout": "page",
				"path": "/menu/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "mixins.md",
				"ext": "md",
				"name": "mixins",
				"extname": ".md",
				"basename": "mixins.md",
				"dirname": "pages",
				"stem": "mixins",
				"path": "pages/mixins.md"
			},
			"requirePath": "pages/mixins.md",
			"path": "/mixins/",
			"data": {
				"title": "Mixins",
				"layout": "post",
				"path": "/mixins/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/projects",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/projects",
				"stem": "index",
				"path": "pages/projects/index.md"
			},
			"requirePath": "pages/projects/index.md",
			"path": "/projects/",
			"data": {
				"title": "Projects",
				"layout": "page",
				"path": "/projects/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "variables.md",
				"ext": "md",
				"name": "variables",
				"extname": ".md",
				"basename": "variables.md",
				"dirname": "pages",
				"stem": "variables",
				"path": "pages/variables.md"
			},
			"requirePath": "pages/variables.md",
			"path": "/variables/",
			"data": {
				"title": "Variables",
				"layout": "page",
				"path": "/variables/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "bbq-agency.md",
				"ext": "md",
				"name": "bbq-agency",
				"extname": ".md",
				"basename": "bbq-agency.md",
				"dirname": "sites",
				"stem": "bbq-agency",
				"path": "sites/bbq-agency.md"
			},
			"requirePath": "sites/bbq-agency.md",
			"path": "/sites/bbq-agency/",
			"data": {
				"id": 2,
				"date": "2017-02-01T00:00:00.000Z",
				"title": "BBQ Agency",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://bbq.agency",
				"sourceUrl": "https://github.com/bbq-agency/bbq-agency.github.io"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "codereamer.md",
				"ext": "md",
				"name": "codereamer",
				"extname": ".md",
				"basename": "codereamer.md",
				"dirname": "sites",
				"stem": "codereamer",
				"path": "sites/codereamer.md"
			},
			"requirePath": "sites/codereamer.md",
			"path": "/sites/codereamer/",
			"data": {
				"id": 11,
				"date": "2016-05-01T00:00:00.000Z",
				"title": "Codereamer",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://rooooster.github.io/codereamer",
				"sourceUrl": "https://github.com/rooooster/codereamer"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "coriolan-ui.md",
				"ext": "md",
				"name": "coriolan-ui",
				"extname": ".md",
				"basename": "coriolan-ui.md",
				"dirname": "sites",
				"stem": "coriolan-ui",
				"path": "sites/coriolan-ui.md"
			},
			"requirePath": "sites/coriolan-ui.md",
			"path": "/sites/coriolan-ui/",
			"data": {
				"id": 3,
				"date": "2016-03-01T00:00:00.000Z",
				"title": "Coriolan UI",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://coriolan-ui.github.io",
				"sourceUrl": "https://github.com/coriolan-ui/coriolan-ui.github.io"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "ihororlovskyi.md",
				"ext": "md",
				"name": "ihororlovskyi",
				"extname": ".md",
				"basename": "ihororlovskyi.md",
				"dirname": "sites",
				"stem": "ihororlovskyi",
				"path": "sites/ihororlovskyi.md"
			},
			"requirePath": "sites/ihororlovskyi.md",
			"path": "/sites/ihororlovskyi/",
			"data": {
				"id": 10,
				"date": "2017-03-01T00:00:00.000Z",
				"title": "Ihor Orlovskyi",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://ihororlovskyi.com",
				"sourceUrl": "https://github.com/ihororlovskyi/ihororlovskyi"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "mcriviera.md",
				"ext": "md",
				"name": "mcriviera",
				"extname": ".md",
				"basename": "mcriviera.md",
				"dirname": "sites",
				"stem": "mcriviera",
				"path": "sites/mcriviera.md"
			},
			"requirePath": "sites/mcriviera.md",
			"path": "/sites/mcriviera/",
			"data": {
				"id": "08",
				"date": "2015-12-01T00:00:00.000Z",
				"title": "Monte Carlo Riviera",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://mcriviera.com",
				"sourceUrl": "https://github.com/rooooster/mcriviera"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "nebo-agency.md",
				"ext": "md",
				"name": "nebo-agency",
				"extname": ".md",
				"basename": "nebo-agency.md",
				"dirname": "sites",
				"stem": "nebo-agency",
				"path": "sites/nebo-agency.md"
			},
			"requirePath": "sites/nebo-agency.md",
			"path": "/sites/nebo-agency/",
			"data": {
				"id": 4,
				"date": "2016-02-01T00:00:00.000Z",
				"title": "Nebo Agency",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://nebo.ua",
				"sourceUrl": "https://github.com/rooooster/nebo"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "newsman.md",
				"ext": "md",
				"name": "newsman",
				"extname": ".md",
				"basename": "newsman.md",
				"dirname": "sites",
				"stem": "newsman",
				"path": "sites/newsman.md"
			},
			"requirePath": "sites/newsman.md",
			"path": "/sites/newsman/",
			"data": {
				"id": 5,
				"date": "2016-11-01T00:00:00.000Z",
				"title": "Newsman",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://rooooster.github.io/newsman",
				"sourceUrl": "https://github.com/rooooster/newsman"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "rooster-chess.md",
				"ext": "md",
				"name": "rooster-chess",
				"extname": ".md",
				"basename": "rooster-chess.md",
				"dirname": "sites",
				"stem": "rooster-chess",
				"path": "sites/rooster-chess.md"
			},
			"requirePath": "sites/rooster-chess.md",
			"path": "/sites/rooster-chess/",
			"data": {
				"id": 6,
				"date": "2015-08-01T00:00:00.000Z",
				"title": "Rooster Chess",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://rooster-chess.netlify.com",
				"sourceUrl": "https://github.com/rooooster/rooster-chess"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "sentimony.md",
				"ext": "md",
				"name": "sentimony",
				"extname": ".md",
				"basename": "sentimony.md",
				"dirname": "sites",
				"stem": "sentimony",
				"path": "sites/sentimony.md"
			},
			"requirePath": "sites/sentimony.md",
			"path": "/sites/sentimony/",
			"data": {
				"id": 1,
				"date": "2017-03-01T00:00:00.000Z",
				"title": "Sentimony Records",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://sentimony.com",
				"sourceUrl": "https://github.com/sentimony/sentimony-nuxt"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "skoryk.md",
				"ext": "md",
				"name": "skoryk",
				"extname": ".md",
				"basename": "skoryk.md",
				"dirname": "sites",
				"stem": "skoryk",
				"path": "sites/skoryk.md"
			},
			"requirePath": "sites/skoryk.md",
			"path": "/sites/skoryk/",
			"data": {
				"id": "09",
				"date": "2015-11-01T00:00:00.000Z",
				"title": "Skoryk Competition",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://rooooster.github.io/skoryk",
				"sourceUrl": "https://github.com/rooooster/skoryk"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "sites",
				"base": "vatmanman.md",
				"ext": "md",
				"name": "vatmanman",
				"extname": ".md",
				"basename": "vatmanman.md",
				"dirname": "sites",
				"stem": "vatmanman",
				"path": "sites/vatmanman.md"
			},
			"requirePath": "sites/vatmanman.md",
			"path": "/sites/vatmanman/",
			"data": {
				"id": 12,
				"date": "2016-05-01T00:00:00.000Z",
				"title": "VatmanMan",
				"layout": "post",
				"category": "site",
				"siteUrl": "https://rooooster.github.io/vatmanman",
				"sourceUrl": "https://github.com/rooooster/vatmanman"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0